import React from 'react';
import { CheckIcon } from '../lib/icons';
import { useReveal } from '../lib/useReveal';
const PERSONAL_BENEFITS = ['Identificar y liberar bloqueos emocionales', 'Recuperar calma mental', 'Equilibrar tu energía', 'Practicar autosanación con método', 'Ganar claridad y estabilidad'];
const PROFESSIONAL_BENEFITS = ['Realizar sesiones de Reiki correctamente', 'Ofrecer terapias presenciales o a distancia', 'Trabajar desde casa', 'Construir tu propia consulta', 'Generar ingresos con una habilidad real'];
export function BenefitsSection() {
  const [ref1, vis1] = useReveal();
  const [ref2, vis2] = useReveal();
  return <section className="bg-[#faf5ef] py-20 md:py-28 px-4" data-id="element-35">
      <div className="container mx-auto max-w-5xl" data-id="element-36">
        <div ref={ref1} className={`reveal text-center mb-16 ${vis1 ? 'is-visible' : ''}`} data-id="element-37">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-gray-900 mb-4 leading-tight" data-id="element-38">
            Lo que vas a lograr con esta formación
          </h2>
          <p className="text-xl text-gray-600 font-medium" data-id="element-39">
            Sanación personal + herramienta laboral.
          </p>
        </div>

        <div ref={ref2} className={`reveal grid grid-cols-1 md:grid-cols-2 gap-8 ${vis2 ? 'is-visible' : ''}`} data-id="element-40">
          {/* Personal Benefits */}
          <div className="bg-white rounded-3xl p-8 border border-[#7aaa8a]/20 shadow-sm" data-id="element-41">
            <h3 className="text-2xl font-serif font-bold text-[#3a6a4a] mb-6 flex items-center gap-2" data-id="element-42">
              🌿 En el plano personal
            </h3>
            <ul className="space-y-4" data-id="element-43">
              {PERSONAL_BENEFITS.map((item, idx) => <li key={idx} className="flex items-start gap-3 text-[#2a1f0e] text-lg" data-id="element-44">
                  <div className="mt-1 bg-[#e8f5ec] p-1 rounded-full flex-shrink-0" data-id="element-45">
                    <CheckIcon className="w-4 h-4 text-[#5a8a6a]" strokeWidth={3} data-id="element-46" />
                  </div>
                  <span data-id="element-47">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* Professional Benefits */}
          <div className="bg-white rounded-3xl p-8 border border-[#d4a017]/20 shadow-sm" data-id="element-48">
            <h3 className="text-2xl font-serif font-bold text-[#8a6010] mb-6 flex items-center gap-2" data-id="element-49">
              💼 En el plano profesional
            </h3>
            <ul className="space-y-4" data-id="element-50">
              {PROFESSIONAL_BENEFITS.map((item, idx) => <li key={idx} className="flex items-start gap-3 text-[#2a1f0e] text-lg" data-id="element-51">
                  <div className="mt-1 bg-[#fdf3dc] p-1 rounded-full flex-shrink-0" data-id="element-52">
                    <CheckIcon className="w-4 h-4 text-[#b8860b]" strokeWidth={3} data-id="element-53" />
                  </div>
                  <span data-id="element-54">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}